/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ApportDto } from '../models/apport-dto';
import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des apports lors d'une visite
 */
@Injectable({
  providedIn: 'root',
})
export class ApportsVisiteService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apportsVisiteGetList
   */
  static readonly ApportsVisiteGetListPath = '/api/apports-visite';

  /**
   * Renvoie la liste des apports de la visite spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apportsVisiteGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  apportsVisiteGetList$Response(params?: {

    /**
     * Identifiant de la visite
     */
    visiteId?: number;
  }): Observable<StrictHttpResponse<Array<ApportDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ApportsVisiteService.ApportsVisiteGetListPath, 'get');
    if (params) {
      rb.query('visiteId', params.visiteId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ApportDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des apports de la visite spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apportsVisiteGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apportsVisiteGetList(params?: {

    /**
     * Identifiant de la visite
     */
    visiteId?: number;
  }): Observable<Array<ApportDto>> {

    return this.apportsVisiteGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ApportDto>>) => r.body as Array<ApportDto>)
    );
  }

  /**
   * Path part for operation apportsVisiteLoadList
   */
  static readonly ApportsVisiteLoadListPath = '/api/apports-visite/load-list/{visiteId}';

  /**
   * Renvoie la apports de la visite spécifiée (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apportsVisiteLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apportsVisiteLoadList$Response(params: {

    /**
     * Identifiant de la visite
     */
    visiteId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, ApportsVisiteService.ApportsVisiteLoadListPath, 'post');
    if (params) {
      rb.path('visiteId', params.visiteId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la apports de la visite spécifiée (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apportsVisiteLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apportsVisiteLoadList(params: {

    /**
     * Identifiant de la visite
     */
    visiteId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.apportsVisiteLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation apportsVisiteGet
   */
  static readonly ApportsVisiteGetPath = '/api/apports-visite/{id}';

  /**
   * Renvoie l'apport spécifié pour la visite spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apportsVisiteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apportsVisiteGet$Response(params: {

    /**
     * Identifiant de l&#x27;apport
     */
    id: number;
  }): Observable<StrictHttpResponse<ApportDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApportsVisiteService.ApportsVisiteGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ApportDto>;
      })
    );
  }

  /**
   * Renvoie l'apport spécifié pour la visite spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apportsVisiteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apportsVisiteGet(params: {

    /**
     * Identifiant de l&#x27;apport
     */
    id: number;
  }): Observable<ApportDto> {

    return this.apportsVisiteGet$Response(params).pipe(
      map((r: StrictHttpResponse<ApportDto>) => r.body as ApportDto)
    );
  }

  /**
   * Path part for operation apportsVisitePut
   */
  static readonly ApportsVisitePutPath = '/api/apports-visite/{id}';

  /**
   * Met à jour l'apport spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apportsVisitePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apportsVisitePut$Response(params: {

    /**
     * Identifiant de l&#x27;apport à mettre à jour
     */
    id: number;

    /**
     * Apport
     */
    body: ApportDto
  }): Observable<StrictHttpResponse<ApportDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApportsVisiteService.ApportsVisitePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ApportDto>;
      })
    );
  }

  /**
   * Met à jour l'apport spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apportsVisitePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apportsVisitePut(params: {

    /**
     * Identifiant de l&#x27;apport à mettre à jour
     */
    id: number;

    /**
     * Apport
     */
    body: ApportDto
  }): Observable<ApportDto> {

    return this.apportsVisitePut$Response(params).pipe(
      map((r: StrictHttpResponse<ApportDto>) => r.body as ApportDto)
    );
  }

  /**
   * Path part for operation apportsVisiteDelete
   */
  static readonly ApportsVisiteDeletePath = '/api/apports-visite/{id}';

  /**
   * Supprime l'apport spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apportsVisiteDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apportsVisiteDelete$Response(params: {

    /**
     * Identifiant de l&#x27;apport à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, ApportsVisiteService.ApportsVisiteDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime l'apport spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apportsVisiteDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apportsVisiteDelete(params: {

    /**
     * Identifiant de l&#x27;apport à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.apportsVisiteDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation apportsVisitePost
   */
  static readonly ApportsVisitePostPath = '/api/apports-visite/{visiteId}';

  /**
   * Ajoute l'apport spécifié à la visite spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apportsVisitePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apportsVisitePost$Response(params: {

    /**
     * Identifiant de la visite
     */
    visiteId: number;

    /**
     * Apport
     */
    body: ApportDto
  }): Observable<StrictHttpResponse<ApportDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApportsVisiteService.ApportsVisitePostPath, 'post');
    if (params) {
      rb.path('visiteId', params.visiteId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ApportDto>;
      })
    );
  }

  /**
   * Ajoute l'apport spécifié à la visite spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apportsVisitePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apportsVisitePost(params: {

    /**
     * Identifiant de la visite
     */
    visiteId: number;

    /**
     * Apport
     */
    body: ApportDto
  }): Observable<ApportDto> {

    return this.apportsVisitePost$Response(params).pipe(
      map((r: StrictHttpResponse<ApportDto>) => r.body as ApportDto)
    );
  }

  /**
   * Path part for operation apportsVisiteDeleteByTypeDechet
   */
  static readonly ApportsVisiteDeleteByTypeDechetPath = '/api/apports-visite/delete-by-type-dechets/{visiteId}/{typeDechetId}';

  /**
   * Supprime les apports d'un type de déchets spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apportsVisiteDeleteByTypeDechet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apportsVisiteDeleteByTypeDechet$Response(params: {

    /**
     * Identifiant de la visite
     */
    visiteId: number;

    /**
     * Identifiant du type de déchets
     */
    typeDechetId: number;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ApportsVisiteService.ApportsVisiteDeleteByTypeDechetPath, 'delete');
    if (params) {
      rb.path('visiteId', params.visiteId, {});
      rb.path('typeDechetId', params.typeDechetId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Supprime les apports d'un type de déchets spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apportsVisiteDeleteByTypeDechet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apportsVisiteDeleteByTypeDechet(params: {

    /**
     * Identifiant de la visite
     */
    visiteId: number;

    /**
     * Identifiant du type de déchets
     */
    typeDechetId: number;
  }): Observable<void> {

    return this.apportsVisiteDeleteByTypeDechet$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
